export default class Form {
    
    constructor()
    {
        Form.select();
        Form.input_focused();
        Form.comment_note();
    }
    
    static select()
    {
        $( 'select' ).parent().not( '.formSelect' ).children( 'select' ).wrap( '<div class="formSelect"></div>' );
    }
    
    static input_focused()
    {
        $( '.formGroup:not(.no-animate)' ).on( 'focusin change', function ( e ) {
            $( this ).addClass( 'is-focused' );
        } );
        
        $( '.formGroup:not(.no-animate)' ).on( 'focusout change', function ( e ) {
            let input    = $( this ).find( 'input' );
            let textarea = $( this ).find( 'textarea' );
            let select   = $( this ).find( 'select' );
            
            if ( (
                     !$( input ).val()
                 ) && (
                     !$( textarea ).val()
                 ) && (
                     !$( select ).val()
                 ) ) {
                $( this ).removeClass( 'is-focused' );
            }
        } );
    }
    
    static comment_note()
    {
        if ( $( '[data-id="comment-note"]' ).length != 0 ) {
            $( '[data-id="comment-note"] input.radio-vote' ).on( 'click', function () {
                let wrap = $( '[data-id="comment-note"] .radio-wrapper' );
                let val  = wrap.find( "input[name='vote']:checked" ).val();
                wrap.removeClass( 'etat_1 etat_2 etat_3 etat_4 etat_5' );
                wrap.addClass( 'etat_' + val );
            } );
        }
    }
}